import React, { useState,useEffect } from 'react'
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import NotePanelContainer from "../../containers/WorkkardDetail/NotePanelContainer";
import { setActiveTopHeader } from '../Header/actions/action';
import { showRightPopUpeBox, hideRightPopUpBox } from "../../components/RightPopUpComponent/actions";
import { CHOOSE_AN_ACTIVITY_TEMPLATE, CharConstants, StringConstants } from '../../containers/WorkkardDetail/constants';
import { getWorkkardDetailMasterData, setPanelVisibility, getActivityDetail } from "../../containers/WorkkardDetail/actions/action";
import Toast from '../../components/Toast';
import DiaryCreation from "./DiaryCreation";
import ChoseReason from "../../components/ChoseReason";
import { showDialogueBox} from '../../components/DialogueBox/actions';
import { getQueryParam } from "../../common/util";
import { hideToast } from '../SpockViewPage/actions/action';

const CreationForms = (props) => {

    const [referrer,setReferrer]=useState('');
    const dispatch = useDispatch();
    const { dialogueBox, tooltip, workkardDetail, rightPopUpComponent, toast } = useSelector(state => ({
        dialogueBox: state.dialogueBox,
        tooltip: state.tooltip,
        workkardDetail: state.workkardDetail.workkardDetail,
        rightPopUpComponent: state.rightPopUpComponent,
        toast: state.toast
    }), shallowEqual);

    useEffect(() => {
        // code to run on component mount 
        window.addEventListener('addDiaryClicked', (e) => {
            showCreationForm(<DiaryCreation onClose={onDialogueClose} {...e.detail} />,"diary")
        });
        window.addEventListener('addNotePopUp', (e) => {
            if (e.detail) {
                setReferrer(e.detail.referrer);
                e.detail.type === "activity" ? dispatch(getActivityDetail({ actId: e.detail.moduleId, referrer: e.detail.referrer })) :
                    dispatch(getWorkkardDetailMasterData({ cId: e.detail.moduleId, doNotUpdateActivityListing: true, updateActivityDetail:true, referrer: e.detail.referrer}));   
                const panelVisibilityData = {
                    templateType: e.detail.type === "workkard" ? CharConstants.Workkard : CharConstants.Activity,
                    isNoteVisible: true
                }
                dispatch(setPanelVisibility(panelVisibilityData));
                dispatch(setActiveTopHeader({ activeHeader: ''}));
                showRightPopUpBox(<NotePanelContainer onClose={onCloseRightPopUp}  {...e.detail} />, "viewNotePanel");
            }
        });
        window.addEventListener('addActivityClicked', (e) => {
            showCreationForm(<ChoseReason isCreateActivity={true} wkid={e.detail.wkId} isAddActivityEvent={true} onClose={(data)=>onDialogueClose(data)} title={CHOOSE_AN_ACTIVITY_TEMPLATE} referrer={e.detail.referrer} />,"activity")
        }); 
    }, []);

    const onCloseRightPopUp = () => {
        let isTopHeaderActive = $(".headerRight li").is('[name]');
        if (!isTopHeaderActive) {
            dispatch(hideRightPopUpBox());
        }
    }

    const showRightPopUpBox = (childComponent, panel, type) => {
        let isTopHeaderActive = $(".headerRight li").is('[name]');
        if (isTopHeaderActive) {
            $(".headerRight li").removeAttr("name");
        }
        if (rightPopUpComponent.flag) {
            dispatch(hideRightPopUpBox());
        }
        dispatch(showRightPopUpeBox({
            flag: true,
            component: childComponent,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick: true,
            type: type || "open",
            panelType: panel
        }));

    }

    const showCreationForm = (childComponent,type) => {
        if(type=="activity" && Object.keys(workkardDetail).length==0){
        dispatch(getWorkkardDetailMasterData({cId:childComponent.props.wkid,doNotUpdateActivityListing:true}));
        }
        dispatch(showDialogueBox({
            flag: true,
            component: childComponent,
            overlayClassName:type=="activity" ? "modal" : "modal fullViewMain",
            contentClassName:type=="activity" ? "modalContent medium animated faster fadeInUpx2" : "modalContent fullView animated faster fadeInUpx2 medium",
            shouldCloseOnOverlayClick:type=="activity" ? true: false
        }))
    }

    const onDialogueClose = (data) => {
        dispatch(showDialogueBox({
            flag: false,
            title: null,
            dialogueBoxComponent: null
        }));
        if(data){
         window.location = "/" + getQueryParam("ret") + window.location.hash;   
        }
    }

    const onViewToastClick = (type, cid, actid) => {
        if (type == StringConstants.activity) {
            window.open('/getclmdetail?cId=' + cid + "&actId=" + actid + "&#an",'_blank');
        }
        else {
            window.open('/getclmdetail?cId=' + cid +"&#cn",'_blank'); 
        }

    }

    return (
        <>
            {toast.show && toast.entityType!="timezone" && referrer!=""
                && <Toast
                    message={toast.message}
                    iconType="success"
                    type={toast.type}
                    delayTime={toast.delayTime}
                    closeToast={() => dispatch(hideToast())}
                    show={toast.show}
                    entityType={toast.entityType}
                    cId={toast.cId}
                    actId={toast.actId}
                    onViewToastClick={onViewToastClick}
                    showActions={toast.showActions}
                    isCloseIcon={toast.isCloseIcon}
                    autoClose={toast.autoClose}
                    addStyle={true}
                >
                </Toast>
            }

        </>
    )
}

export default CreationForms;

